import { ICompleteQueryResponse } from './types';

export const fetchCompleteQuery = async (
  query: string,
  locale: string
): Promise<ICompleteQueryResponse | null> => {
  try {
    return await fetch(
      `/api/google/retail/complete-query?query=${query}&locale=${locale}`
    ).then((res) => res.json());
  } catch (e) {
    return null;
  }
};
